function Socials() {
  return "🛸"
}

export default Socials